export default class PersistStore<T = HashAny> {
  constructor(
    public key: string,
    private options: Partial<{
      storage: Storage;
      toJSON: (module: T) => HashAny;
      shouldThrow: boolean;
      debug: boolean;
    }> = {},
  ) {}

  load(): HashAny {
    try {
      return (
        JSON.parse(
          (this.options.storage || localStorage).getItem(this.key) || '{}',
        ) || {}
      );
    } catch (e) {
      return {};
    }
  }

  persist(module: T) {
    try {
      const value =
        typeof this.options.toJSON === 'function'
          ? this.options.toJSON(module)
          : module;
      (this.options.storage || localStorage).setItem(
        this.key,
        JSON.stringify(value),
      );
    } catch (e) {
      if (this.options.debug) {
        window.console.log(`Error while persisting ${this.key}:`);
        window.console.error(e);
      }
      if (this.options.shouldThrow) {
        throw e;
      }
    }
  }

  clear() {
    try {
      (this.options.storage || localStorage).removeItem(this.key);
    } catch (e) {
      // ignore
    }
  }
}
